import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Client, Contract } from '../../../domain/data';
import { ClientType } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-appropriateness-table',
    templateUrl: './full-data-appropriateness-table.component.html',
    styleUrls: ['./full-data-appropriateness-table.component.scss'],
})
export class FullDataAppropriatenessTableComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ClientType: typeof ClientType = ClientType;

    @Input()
    contract: Contract;

    @Input()
    participants: Client[] = [];

    @Input()
    isDisabled = false;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
